import React, { useRef } from "react";
import "./styles.css";
import mahesh from "../../assets/img/mahesh.jpeg";
import jeetu from "../../assets/img/jeetu.jpeg";
import kumar from "../../assets/img/kumar.jpeg";
import priya from "../../assets/img/priya.jpeg";
import bhavna from "../../assets/img/bhavna.jpeg";
import rekha from "../../assets/img/rekha.jpeg";

const AITeachers = () => {
  const scrollContainerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = React.useState(false);
  const [showRightArrow, setShowRightArrow] = React.useState(true);

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } =
        scrollContainerRef.current;

      setShowLeftArrow(scrollLeft > 20);

      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 20);
    }
  };

  React.useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);

      // Initial check
      handleScroll();

      return () => {
        scrollContainer.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const teacherImages = {
    mahesh: {
      webp: require("../../assets/img/mahesh.webp"),
      jpeg: mahesh,
    },
    jeetu: {
      webp: require("../../assets/img/jeetu.webp"),
      jpeg: jeetu,
    },
    kumar: {
      webp: require("../../assets/img/kumar.webp"),
      jpeg: kumar,
    },
    priya: {
      webp: require("../../assets/img/priya.webp"),
      jpeg: priya,
    },
    bhavna: {
      webp: require("../../assets/img/bhavna.webp"),
      jpeg: bhavna,
    },
    rekha: {
      webp: require("../../assets/img/rekha.webp"),
      jpeg: rekha,
    },
  };

  return (
    <section className="ai-teachers-section">
      <div className="container">
        <div className="ai-teachers-header">
          <div className="section-badge">AI Teachers</div>
          <h3 className="section-title">Meet Your Personal AI Teaching Team</h3>
          <p className="section-subtitle">
            Each AI teacher has a unique personality and specialized teaching
            style to help you master different subjects
          </p>
          <p className="scroll-hint">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ verticalAlign: "middle", marginRight: "5px" }}
            >
              <path
                d="M17 8L21 12M21 12L17 16M21 12H3"
                stroke="#FF4A00"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Swipe to see more teachers
          </p>
        </div>

        <div className="ai-teachers-grid-container">
          {showLeftArrow && (
            <div className="scroll-indicator scroll-left" onClick={scrollLeft}>
              <svg
                className="scroll-indicator-icon"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
              </svg>
            </div>
          )}
          {showRightArrow && (
            <div
              className="scroll-indicator scroll-right"
              onClick={scrollRight}
            >
              <svg
                className="scroll-indicator-icon"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
              </svg>
            </div>
          )}

          <div className="ai-teachers-grid" ref={scrollContainerRef}>
            {[
              {
                id: "rekha",
                name: "Rekha Ma'am",
                specialty: "Holistic, innovative, encouraging",
                avatar: rekha,
                personality: [
                  "Connects concepts across different subjects",
                ],
              },

              {
                id: "priya",
                name: "Priya Ma'am",
                specialty: "Supportive, encouraging, stress-reducing",
                avatar: priya,
                personality: [
                  "Focuses on emotional well-being alongside academic progress, normalizing mistakes and celebrating effort",
                ],
              },
              {
                id: "bhavna",
                name: "Isha Ma'am",
                specialty: "Empathetic, insightful, communicative",
                avatar: bhavna,
                personality: [
                  "Encourages critical thinking through literature",
                ],
              },
              {
                id: "mahesh",
                name: "Mahesh Sir",
                specialty: "Strict, attention-to-detail, encouraging",
                avatar: mahesh,
                personality: [
                  "Explains complex concepts with real-world examples",
                ],
              },

              {
                id: "sharma",
                name: "Jeetu Sir",
                specialty: "Engaging, relatable, creative",
                avatar: jeetu,
                personality: [
                  "Turns lessons into stories with characters and real-life examples that make complex ideas memorable",
                ],
              },

              {
                id: "kumar",
                name: "Parth Sir",
                specialty: "Hands-on, interactive, feedback-driven",
                avatar: kumar,
                personality: [
                  "Believes in learning by doing, encouraging students to tackle exercises and refine their methods through reflection",
                ],
              },
            ].map((teacher) => (
              <div key={teacher.id} className="teacher-card">
                <div className="teacher-avatar-container">
                  <picture>
                    {teacher.id !== "sharma" && (
                      <source
                        srcSet={teacherImages[teacher.id]?.webp}
                        type="image/webp"
                      />
                    )}
                    <img
                      src={
                        teacher.id === "sharma"
                          ? jeetu
                          : teacherImages[teacher.id]?.jpeg
                      }
                      alt={`${teacher.name} Avatar`}
                      className="teacher-avatar"
                      style={
                        teacher.id === "priya" ? { width: "230px" } : {}
                      }
                      width="200"
                      height="200"
                    />
                  </picture>
                </div>
                <div className="teacher-info">
                  <div className="teacher-name-container">
                    <h4 className="teacher-name">
                      {teacher.name}
                      <span className="ai-trademark">AI</span>
                    </h4>
                  </div>
                  <div className="teacher-title">{teacher.title}</div>
                  <p className="teacher-description">{teacher.description}</p>
                  <div className="teacher-specialty">{teacher.specialty}</div>
                  <ul className="teacher-personality">
                    {teacher.personality.map((trait, index) => (
                      <li key={index}>{trait}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="teacher-cta-container">
          <button
            className="teacher-cta-button"
            onClick={() =>
              window.open(
                "https://app.aichanakya.in/",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            Start Learning with AI Teachers →
          </button>
        </div>
      </div>
    </section>
  );
};

export default AITeachers;
